/** A deliberately closed projection. Tool output never supplies form values. */
export function parsePetSetupMarker(tool, ok, raw) {
    if (tool !== 'gyro_prepare_pet_setup' || ok !== true || !raw || typeof raw !== 'object' || Array.isArray(raw))
        return;
    const descriptors = Object.getOwnPropertyDescriptors(raw);
    if (Reflect.ownKeys(descriptors).length !== 3 || !['kind', 'version', 'available'].every(key => descriptors[key] && 'value' in descriptors[key]))
        return;
    if (descriptors.kind.value === 'pet-setup-review' && descriptors.version.value === 1 && descriptors.available.value === true)
        return { kind: 'pet-setup-review', version: 1, available: true };
}
export function petSetupDescription(question, attachments) {
    // Reject, never truncate. Attached files, result bodies and chat history are
    // not descriptions and cannot silently become a companion's instructions.
    if (attachments !== 0 || question.length > 4000 || !question.trim())
        return;
    return question;
}
export function petSetupAvailable(catalog) {
    return catalog.capabilities.enabled === true && catalog.capabilities.storageReady === true
        && catalog.capabilities.features?.create === true;
}
export const petSetupReplyCompleted = (mode) => mode === 'ai';
export function showsPetSetupReview(enabled, session, conversationId, message) {
    return enabled && message.role === 'assistant' && !message.pending && !message.streaming && !message.error
        && message.petSetupCompleted === true
        && session.read(message.petSetupReview, conversationId) !== undefined;
}
export class PetSetupHandoffs {
    owner;
    transport;
    now;
    active = true;
    entries = new Map();
    constructor(owner, transport, now = Date.now) {
        this.owner = owner;
        this.transport = transport;
        this.now = now;
    }
    prune() { const now = this.now(); for (const [token, entry] of this.entries)
        if (now < entry.createdAt || now >= entry.expiresAt)
            this.entries.delete(token); }
    offer(conversationId, question, attachments, marker, replyId) {
        this.prune();
        const description = petSetupDescription(question, attachments);
        if (!this.active || !conversationId || description === undefined || !parsePetSetupMarker('gyro_prepare_pet_setup', true, marker))
            return;
        if (replyId)
            for (const [token, entry] of this.entries)
                if (entry.conversationId === conversationId && entry.replyId === replyId)
                    return entry.description === description ? token : undefined;
        if (this.entries.size >= 32)
            return;
        const createdAt = this.now(), token = Object.freeze({});
        this.entries.set(token, { conversationId, description, replyId, createdAt, expiresAt: createdAt + 30 * 60000 });
        return token;
    }
    read(token, conversationId) {
        this.prune();
        const entry = token && this.active ? this.entries.get(token) : undefined;
        return entry?.conversationId === conversationId ? entry.description : undefined;
    }
    consume(token) { this.entries.delete(token); }
    forgetConversation(id) { for (const [token, entry] of this.entries)
        if (entry.conversationId === id)
            this.entries.delete(token); }
    clear() { this.active = false; this.entries.clear(); }
    async review(token, conversationId, catalog, current, signal) {
        const description = this.read(token, conversationId);
        const check = () => {
            signal.throwIfAborted();
            if (description === undefined || !current() || this.read(token, conversationId) !== description)
                throw new Error('This PET setup suggestion is no longer available in the current session.');
        };
        check();
        const fresh = await catalog(signal);
        check();
        if (!petSetupAvailable(fresh))
            throw new Error('Creating a PET is not currently available. Your existing setup has been kept.');
        return description;
    }
}
//# sourceMappingURL=petSetupHandoff.js.map